const OSRM = "https://router.project-osrm.org/route/v1/driving";

const haversineKm = (a, b) => {
  const r = (d) => (d * Math.PI) / 180;
  const dLat = r(b.lat - a.lat), dLng = r(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(r(a.lat)) * Math.cos(r(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 6371 * 2 * Math.asin(Math.sqrt(h));
};

// Swap OSRM for a private/commercial router here without touching the UI.
export async function getRoute(from, to) {
  try {
    const res = await fetch(`${OSRM}/${from.lng},${from.lat};${to.lng},${to.lat}?overview=full&geometries=geojson`);
    const data = await res.json();
    const route = data.routes?.[0];
    if (!res.ok || !route) throw new Error("no route");
    return { road: true, coords: route.geometry.coordinates.map(([lng, lat]) => [lat, lng]),
      distanceKm: route.distance / 1000, durationMin: route.duration / 60 };
  } catch {
    return { road: false, coords: [[from.lat, from.lng], [to.lat, to.lng]], distanceKm: haversineKm(from, to), durationMin: null };
  }
}

export const STP_CENTER = { lat: 0.3365, lng: 6.7273 };
